<template>
  <bita-modal
    :id="modalId"
    title="تغییر رمز عبور"
    :modal-lg="false"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body" class="row">
          <div class="col-12 mb-3" v-if="propsUser && propsUser.id">
            <div class="alert alert-info">
              تغییر رمز برای کاربر:
              <strong>{{ propsUser.username }}</strong>
              <span v-if="propsUser.name">
                ({{ propsUser.name }} {{ propsUser.family }})
              </span>
            </div>
          </div>

          <bita-input
            type="password"
            name="new_password"
            label="رمز جدید"
            rules="required|min:6"
            validation-container-class="col-12"
            input-class="form-control"
            v-model="form.new_password"
          />

          <bita-input
            type="password"
            name="confirm_password"
            label="تکرار رمز جدید"
            rules="required|min:6"
            validation-container-class="col-12"
            input-class="form-control"
            v-model="form.confirm_password"
          />
        </div>
      </bita-form>
    </div>

    <div slot="footer" class="d-flex justify-content-between">
      <div class="col-6">
        <bita-bootbutton
          type="primary"
          title="ذخیره" 
          icon="fa fa-check"
          class="w-100"
          @click.native="handleSubmit"
        />
      </div>
      <div class="col-6">
        <bita-bootbutton
          class="w-100 bg-transparent text-danger border-0"
          type="danger"
          title="بستن"
          icon="fas fa-times"
          data-dismiss="modal"
          @click.native="closeModal"
        />
      </div>
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    modalId: { type: String, default: "password-modal" },
    propsUser: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      form: {
        new_password: "",
        confirm_password: "",
      },
    };
  },
  watch: {
    propsUser: function(newUser) {
      this.form.new_password = "";
      this.form.confirm_password = "";
    },
  },
  methods: {
handleSubmit() {
  this.$refs.form.validate().then((result) => {
    if (!result) return;


         this.$emit("on-submit", {
        user_id: this.propsUser.id,          
        new_password: this.form.new_password,
        confirm_password: this.form.confirm_password
      });
  });
}
,
    closeModal() {
      $(`#${this.modalId}`).modal("toggle");
    },
    onCloseModal() {
      this.form.new_password = "";
      this.form.confirm_password = "";
        this.$refs.form.reset();

    },
  },
};
</script>
